import React from 'react';

const PageHeader = ({ title, subtitle, actions }) => (
  <header className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <div className="min-w-0">
      <h1 className="text-[22px] leading-8 font-semibold tracking-[-0.44px] text-ink truncate">
        {title}
      </h1>
      {subtitle && (
        <p className="text-xs leading-[15px] text-ink-muted mt-0.5">{subtitle}</p>
      )}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
  </header>
);

export default PageHeader;
